var path = '/opt/atlassian/pipelines/agent/build/src/app/common/components/google-map/google-map.html';
var html = "<div class=google-map-box> <div class=close-lightBox ng-click=$ctrl.onClose()> <i class=\"fa fa-times\" aria-hidden=true></i> </div> <div class=google-map> <div id=map></div> <div class=\"map-buttons pull-right\"> <button ng-click=$ctrl.onClose() type=button class=\"btn cancel\"> Cancel </button> <button type=button ng-click=$ctrl.onSubmit() class=\"btn submit\"> Ok </button> </div> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/google-map/google-map.html
// module id = 916
// module chunks = 0